import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

export const styles = createTypedSxStyles({
  divider: {
    mx: "8px",
  },
  switch: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    px: "8px",
    color: capitalDesignTokens.foundations.colors.gray700,
    "& input": {
      position: "absolute",
    },
  },
});
